import { SettingsMasterStep } from 'entities/settings-master/model/type';
import { getDeviceTypeTranslate } from 'widgets/settings-master/lib/translate-device-type';
export const getHintTitle = (device_type) => (step, path) => {
    if (step == null) {
        return null;
    }
    const device_name = getDeviceTypeTranslate(device_type);
    if (device_name == null) {
        return null;
    }
    const isRelay = path.includes(SettingsMasterStep.Relay);
    if ((step == SettingsMasterStep.WaterControl && device_type !== 'SMART_ZOTA') ||
        (step == SettingsMasterStep.PZAControl && isRelay)) {
        return `water_${device_name}_new`;
    }
    if ((step == SettingsMasterStep.AirControl && device_type !== 'SMART_ZOTA') ||
        step == SettingsMasterStep.InRoomTemp) {
        return `air_${device_name}_new`;
    }
    if (step == SettingsMasterStep.DigitalBus && device_type === 'SMART_ZOTA') {
        return `connect_wires`;
    }
    if (step == SettingsMasterStep.BoilerNoDHW && device_type === 'SMART_ZOTA') {
        return 'noDhw';
    }
    if (step == SettingsMasterStep.AirControl && device_type === 'SMART_ZOTA') {
        return 'air_zota';
    }
    if (step == SettingsMasterStep.PZAControl && device_type === 'SMART_ZOTA') {
        return 'outside_temperature';
    }
    if (step === SettingsMasterStep.WaterControl && device_type === 'SMART_ZOTA') {
        return 'water_control_zota';
    }
    return null;
};
